/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Spin as AntdSpin } from 'antd';
import clsx from 'clsx';

import './styles.module.less';

const prefixCls = 'ant-spin';

const Spinner = () => (
  <span aria-label="loading" className={clsx(`${prefixCls}-dot`, `${prefixCls}-dot-spin`)}>
    <i className={`${prefixCls}-dot-item`} />
    <i className={`${prefixCls}-dot-item`} />
    <i className={`${prefixCls}-dot-item`} />
    <i className={`${prefixCls}-dot-item`} />
  </span>
);

AntdSpin.setDefaultIndicator(<Spinner />);

export default Spinner;
